//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { AxiosPromise } from 'axios';
import { ApiService, AxiosMethod, IAjaxOptions } from '@Services';
export class BaseApiModelClass< T > {
    constructor(data?: T & {}) {
        if (data)
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (< any >this)[property] = (< any >data)[property];
    }
}
export interface IConfigurationAllParams {
    keys?: string
}
export interface IConfigurationParams {
    body?: ConfigurationModel
}
export interface IDaysParams {
    personId: string
    from: Date
    to: Date
}
export interface IReimportParams {
    periodId: number
    personId: string
}
export interface IRecalculateParams {
    periodId: number
    personId: string
}
export interface IImportParams {
    periodId: number
    allowOverride: boolean
}
export interface IReleaseParams {
    periodId: number
}
export interface IRejectParams {
    periodId: number
}
export interface IReopenParams {
    periodId: number
}
export interface IReadyParams {
    periodId: number
}
export interface IHistoryParams {
    periodId: number
}
export interface IUnfilledParams {
    periodId: number
}
export interface IDownloadGETParams {
    periodId: number
    personId: string
}
export interface IDayParams {
    personId: string
    date: Date
}
export interface IHomeParams {
}
export interface IListParams {
}
export interface IStartParams {
    jobName: string
    body?: JobStartModel
}
export interface IParametersGETParams {
    jobName: string
    triggerName?: string
}
export interface IParametersPOSTParams {
    triggerName: string
    body?: JobSaveParametersModel
}
export interface ICreateParams {
    body?: JobSaveParametersModel
}
export interface IDeleteParams {
    triggerId?: string
    jobName?: string
}
export interface ICheckTriggerNameParams {
    triggerName?: string
}
export interface IStopParams {
    jobName: string
}
export interface IPermissionParams {
}
export interface IListAllParams {
    periodId?: number
    date?: Date
}
export interface IActivitiesParams {
    periodId?: number
    personId?: string
}
export interface IGetPersonPeriodStatusErrorParams {
    personId: string
    periodId: number
}
export interface IPersonSalaryParams {
    personId: string
    dateFrom: Date
    dateTo: Date
}
export interface IRuleGETParams {
    date?: Date
}
export interface IRulePOSTParams {
    body?: RuleCreateModel
}
export interface IGetByIdParams {
    id: number
}
export interface IRulePUTParams {
    id: number
    body?: RuleEditModel
}
export interface IRuleDELETEParams {
    id: number
}
export interface IRestoreParams {
    id: number
}
export interface IDutyParams {
}
export interface IActivityDisplayNamesParams {
}
export interface ILicensesParams {
}
export interface IDuty2Params {
    periodId: number
}
export interface IGroupsParams {
    periodId?: number
}
export interface IGroupGETParams {
    id?: number
}
export interface IGroupPUTParams {
    body?: RuleGroupUpdateModel
}
export interface IUsageParams {
    id?: number
}
export interface IDownloadGET2Params {
}
export interface IUploadParams {
    formModel?: FileParameter
}
export interface IValidateParams {
    date: Date
    personId: string
}
export interface IDownloadGET3Params {
    date: Date
    personId: string
}
export interface IHistory2Params {
    ruleId: number
}
export interface ISalaryForPeriodParams {
    periodId: number
}
export interface ISalaryForPeriodByPersonParams {
    periodId: number
    personId: string
}
export interface ISalaryForPersonParams {
    periodId: number
    personId: string
}
export interface ISalaryForDayCorrectionUpdateParams {
    periodId: number
    personId: string
    date: Date
    ruleGroupId: number
    sapAccount: number
    unit: SalaryItemUnit
    body?: DayCorrectionModel
}
export interface ISalaryForDayCorrectionDeleteParams {
    periodId: number
    personId: string
    date: Date
    ruleGroupId: number
    sapAccount: number
    unit: SalaryItemUnit
}
export interface IPeriodsParams {
    status?: SalaryPeriodStatus
}
export interface IDownloadPOSTParams {
    periodId?: number
    typeId?: number
    formModel?: FileParameter
}
export interface IUpload2Params {
    periodId?: number
    typeId?: number
    formModel?: FileParameter
}
export interface IImportTypesParams {
}
export interface ITypeParams {
    personId: string
    periodId: number
    typeId: number
}
export interface ISalaryItemPOSTParams {
    body?: SalaryItemCreateModel
}
export interface ISalaryItemPUTParams {
    id: number
    body?: SalaryItemViewModel
}
export interface ISalaryItemDELETEParams {
    id: number
}
export interface IDownloadSampleParams {
    importType: number
}
export interface IExportParams {
    body?: ExportMonthOverviewFilter
}
export interface IExport2Params {
    body?: ExportMonthOverviewFilter
}
export interface IMonitoringParams {
}
export interface IJobParams {
    jobName: string
    duration?: number
}
export interface IJobsPOSTParams {
}
export interface IEmailqueueParams {
}
export interface IJobsGETParams {
}
export interface IDatabasePOSTParams {
}
export interface IDatabaseGETParams {
}
export interface IUpdateDatabaseParams {
}
export interface IDownloadMessagesParams {
    fromDateTime?: Date
    toDateTime?: Date
    labelFilter?: string
}
export interface IMessagesDatesParams {
}
export interface ILogFilesParams {
    date?: Date
}
export interface IDownloadLogParams {
    file?: string
}
export interface IDownloadLogGzParams {
    file?: string
}
export interface ILogFileParams {
    file?: string
}
export interface IDownloadDeadlettersParams {
}
export interface IDatesParams {
}
export interface IMessageStatisticsParams {
    dateTimeFrom?: Date
}
export interface IRestartSchedulerParams {
}
export interface IInputQueueStatisticsParams {
}
export interface IInputQueueDeadlettersAllParams {
}
export interface IInputQueueDeadlettersParams {
    id?: string
}
export interface IDownloadGET4Params {
}
export interface ISignalRUserParams {
}
export class ApiClient {
    private baseUrl: string;
    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    configurationGet(params?:IConfigurationAllParams, requestOptions?: IAjaxOptions): AxiosPromise<ConfigurationModel[]> {
        let _url = this.baseUrl + "/api/Configuration";

        return ApiService.sendRequest<ConfigurationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    configurationPut(body: ConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Configuration";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    dutyByPersonIdDaysGet(params?:IDaysParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyViewModel[]> {
        let _url = this.baseUrl + "/api/Duty/{personId}/days";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<DutyViewModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdPersonByPersonIdReimportPut(params?:IReimportParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/person/{personId}/reimport";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdPersonByPersonIdRecalculatePut(params?:IRecalculateParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/person/{personId}/recalculate";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdAllowOverrideByAllowOverrideImportPut(params?:IImportParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/allowOverride/{allowOverride}/import";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdReleasePut(params?:IReleaseParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/release";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdRejectPut(params?:IRejectParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/reject";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdReopenPut(params?:IReopenParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/reopen";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdReadyPut(params?:IReadyParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/ready";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdHistoryGet(params?:IHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<SalaryPeriodHistoryResponseModel> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/history";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<SalaryPeriodHistoryResponseModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdPersonsUnfilledGet(params?:IUnfilledParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonCode[]> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/persons/unfilled";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<PersonCode[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    dutyPeriodByPeriodIdPersonByPersonIdDownloadGet(params?:IDownloadGETParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/period/{periodId}/person/{personId}/download";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    dutyByPersonIdDayGet(params?:IDayParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonDayInfoResponse> {
        let _url = this.baseUrl + "/api/Duty/{personId}/day";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<PersonDayInfoResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    homeGet( requestOptions?: IAjaxOptions): AxiosPromise<any[]> {
        let _url = this.baseUrl + "/Home";

        return ApiService.sendRequest<any[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    jobListGet( requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobList> {
        let _url = this.baseUrl + "/api/Job/list";

        return ApiService.sendRequest<ApiV1JobList>(AxiosMethod.GET, _url, null, requestOptions);
    }

    jobStartByJobNamePost(jobName: string, body: JobStartModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/start/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        const content_ = body;
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    jobParametersByJobNameGet(params?:IParametersGETParams, requestOptions?: IAjaxOptions): AxiosPromise<JobDetailsModel> {
        let _url = this.baseUrl + "/api/Job/parameters/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<JobDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    jobParametersByTriggerNamePost(triggerName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/parameters/{triggerName}";
        _url = ApiService.getDynamicUrl(_url, { triggerName, body });
        const content_ = body;
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    jobCreatePost(body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/create";
        const content_ = body;
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    jobDeleteDelete(params?:IDeleteParams, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/delete";

        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    jobCheckTriggerNameGet(params?:ICheckTriggerNameParams, requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/Job/check-trigger-name";

        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, params, requestOptions);
    }

    jobStopByJobNamePost(params?:IStopParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/stop/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }

    permissionGet( requestOptions?: IAjaxOptions): AxiosPromise<PermissionsResult> {
        let _url = this.baseUrl + "/api/permission";

        return ApiService.sendRequest<PermissionsResult>(AxiosMethod.GET, _url, null, requestOptions);
    }

    personListGet(params?:IListAllParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonInfo[]> {
        let _url = this.baseUrl + "/api/Person/list";

        return ApiService.sendRequest<PersonInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    personActivitiesGet(params?:IActivitiesParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonActivitiesInfo[]> {
        let _url = this.baseUrl + "/api/Person/activities";

        return ApiService.sendRequest<PersonActivitiesInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    personByPersonIdPeriodByPeriodIdStatusErrorGet(params?:IGetPersonPeriodStatusErrorParams, requestOptions?: IAjaxOptions): AxiosPromise<ApiResult> {
        let _url = this.baseUrl + "/api/Person/{personId}/period/{periodId}/statusError";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<ApiResult>(AxiosMethod.GET, _url, params, requestOptions);
    }

    personSalaryByPersonIdByDateFromByDateToGet(params?:IPersonSalaryParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonSalaryResponse> {
        let _url = this.baseUrl + "/api/PersonSalary/{personId}/{dateFrom}/{dateTo}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<PersonSalaryResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleGet(params?:IRuleGETParams, requestOptions?: IAjaxOptions): AxiosPromise<RuleListResponse> {
        let _url = this.baseUrl + "/api/Rule";

        return ApiService.sendRequest<RuleListResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    rulePost(body: RuleCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<RuleModel> {
        let _url = this.baseUrl + "/api/Rule";
        const content_ = body;
        return ApiService.sendRequest<RuleModel>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    ruleByIdGet(params?:IGetByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<RuleModel> {
        let _url = this.baseUrl + "/api/Rule/{id}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<RuleModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleByIdPut(id: number, body: RuleEditModel, requestOptions?: IAjaxOptions): AxiosPromise<RuleModel> {
        let _url = this.baseUrl + "/api/Rule/{id}";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        const content_ = body;
        return ApiService.sendRequest<RuleModel>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    ruleByIdDelete(params?:IRuleDELETEParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Rule/{id}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    ruleRestoreByIdPut(params?:IRestoreParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Rule/restore/{id}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    ruleDutyGet( requestOptions?: IAjaxOptions): AxiosPromise<RuleDutyResponse> {
        let _url = this.baseUrl + "/api/Rule/duty";

        return ApiService.sendRequest<RuleDutyResponse>(AxiosMethod.GET, _url, null, requestOptions);
    }

    ruleActivityDisplayNamesGet( requestOptions?: IAjaxOptions): AxiosPromise<ActivityDisplayNameResponse> {
        let _url = this.baseUrl + "/api/Rule/activity-display-names";

        return ApiService.sendRequest<ActivityDisplayNameResponse>(AxiosMethod.GET, _url, null, requestOptions);
    }

    ruleLicensesGet( requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Rule/licenses";

        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    ruleDutyByPeriodIdGet(params?:IDuty2Params, requestOptions?: IAjaxOptions): AxiosPromise<RuleDutyResponse> {
        let _url = this.baseUrl + "/api/Rule/duty/{periodId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<RuleDutyResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleGroupsGet(params?:IGroupsParams, requestOptions?: IAjaxOptions): AxiosPromise<RuleGroupResponse> {
        let _url = this.baseUrl + "/api/Rule/groups";

        return ApiService.sendRequest<RuleGroupResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleGroupGet(params?:IGroupGETParams, requestOptions?: IAjaxOptions): AxiosPromise<RuleGroupModel> {
        let _url = this.baseUrl + "/api/Rule/group";

        return ApiService.sendRequest<RuleGroupModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleGroupPut(body: RuleGroupUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Rule/group";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    ruleUsageGet(params?:IUsageParams, requestOptions?: IAjaxOptions): AxiosPromise<RuleUsageModel> {
        let _url = this.baseUrl + "/api/Rule/usage";

        return ApiService.sendRequest<RuleUsageModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleDownloadGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Rule/download";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }

    ruleUploadPost(formModel: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Rule/upload";
        const content_ = new FormData();
        if (formModel === null || formModel === undefined)
            throw new Error("The parameter 'formModel' cannot be null.");
        else
            content_.append("FormModel", formModel.data, formModel.fileName ? formModel.fileName : "FormModel");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    ruleValidateGet(params?:IValidateParams, requestOptions?: IAjaxOptions): AxiosPromise<ValidatePeriodResultResponse> {
        let _url = this.baseUrl + "/api/Rule/validate";

        return ApiService.sendRequest<ValidatePeriodResultResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleValidateDownloadGet(params?:IDownloadGET3Params, requestOptions?: IAjaxOptions): AxiosPromise<ValidatePeriodResultResponse> {
        let _url = this.baseUrl + "/api/Rule/validate/download";

        return ApiService.sendRequest<ValidatePeriodResultResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    ruleHistoryGet(params?:IHistory2Params, requestOptions?: IAjaxOptions): AxiosPromise<RuleHistoryResponse> {
        let _url = this.baseUrl + "/api/Rule/history";

        return ApiService.sendRequest<RuleHistoryResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    salaryPeriodByPeriodIdGet(params?:ISalaryForPeriodParams, requestOptions?: IAjaxOptions): AxiosPromise<SalaryMonthViewModelResponse[]> {
        let _url = this.baseUrl + "/api/Salary/period/{periodId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<SalaryMonthViewModelResponse[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    salaryPeriodByPeriodIdByPersonIdGet(params?:ISalaryForPeriodByPersonParams, requestOptions?: IAjaxOptions): AxiosPromise<SalaryMonthViewModelResponse> {
        let _url = this.baseUrl + "/api/Salary/period/{periodId}/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<SalaryMonthViewModelResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    salaryDayByPeriodIdByPersonIdGet(params?:ISalaryForPersonParams, requestOptions?: IAjaxOptions): AxiosPromise<SalaryDailyViewModelResponse> {
        let _url = this.baseUrl + "/api/Salary/day/{periodId}/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<SalaryDailyViewModelResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }


    salaryDayByPeriodIdByPersonIdByDateByRuleGroupIdBySapAccountByUnitPut(periodId: number, personId: string, date: Date, ruleGroupId: number, sapAccount: number, unit: SalaryItemUnit, body: DayCorrectionModel, requestOptions?: IAjaxOptions): AxiosPromise<SalaryDailyViewModelResponseItem> {
        let _url = this.baseUrl + "/api/Salary/day/{periodId}/{personId}/{date}/{ruleGroupId}/{sapAccount}/{unit}";
        _url = ApiService.getDynamicUrl(_url, { periodId, personId, date, ruleGroupId, sapAccount, unit, body });
        const content_ = body;
        return ApiService.sendRequest<SalaryDailyViewModelResponseItem>(AxiosMethod.PUT, _url, content_, requestOptions);
    }


    salaryDayByPeriodIdByPersonIdByDateByRuleGroupIdBySapAccountByUnitDelete(params?:ISalaryForDayCorrectionDeleteParams, requestOptions?: IAjaxOptions): AxiosPromise<SalaryDailyViewModelResponseItem> {
        let _url = this.baseUrl + "/api/Salary/day/{periodId}/{personId}/{date}/{ruleGroupId}/{sapAccount}/{unit}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<SalaryDailyViewModelResponseItem>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    salaryPeriodsGet(params?:IPeriodsParams, requestOptions?: IAjaxOptions): AxiosPromise<SalaryPeriodResponseItem[]> {
        let _url = this.baseUrl + "/api/Salary/periods";

        return ApiService.sendRequest<SalaryPeriodResponseItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    salaryValidateDownloadPost(periodId: number, typeId: number, formModel: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<FileResponse> {
        let _url = this.baseUrl + "/api/Salary/validate/download";
        const content_ = new FormData();
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("PeriodId", periodId.toString());
        if (typeId === null || typeId === undefined)
            throw new Error("The parameter 'typeId' cannot be null.");
        else
            content_.append("TypeId", typeId.toString());
        if (formModel === null || formModel === undefined)
            throw new Error("The parameter 'formModel' cannot be null.");
        else
            content_.append("FormModel", formModel.data, formModel.fileName ? formModel.fileName : "FormModel");
        return ApiService.sendRequest<FileResponse>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    salaryUploadPost(periodId: number, typeId: number, formModel: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Salary/upload";
        const content_ = new FormData();
        if (periodId === null || periodId === undefined)
            throw new Error("The parameter 'periodId' cannot be null.");
        else
            content_.append("PeriodId", periodId.toString());
        if (typeId === null || typeId === undefined)
            throw new Error("The parameter 'typeId' cannot be null.");
        else
            content_.append("TypeId", typeId.toString());
        if (formModel === null || formModel === undefined)
            throw new Error("The parameter 'formModel' cannot be null.");
        else
            content_.append("FormModel", formModel.data, formModel.fileName ? formModel.fileName : "FormModel");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    salaryImportTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<ImportTypeModel[]> {
        let _url = this.baseUrl + "/api/Salary/import-types";

        return ApiService.sendRequest<ImportTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    salaryByPersonIdPeriodByPeriodIdTypeByTypeIdGet(params?:ITypeParams, requestOptions?: IAjaxOptions): AxiosPromise<SalaryItemViewModel[]> {
        let _url = this.baseUrl + "/api/Salary/{personId}/period/{periodId}/type/{typeId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<SalaryItemViewModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    salarySalaryItemPost(body: SalaryItemCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Salary/salary-item";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    salarySalaryItemByIdPut(id: number, body: SalaryItemViewModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Salary/salary-item/{id}";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    salarySalaryItemByIdDelete(params?:ISalaryItemDELETEParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Salary/salary-item/{id}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    salaryDownloadSampleGet(params?:IDownloadSampleParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Salary/download-sample";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    salaryOverviewExportPost(body: ExportMonthOverviewFilter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Salary/overview/export";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    salaryCorrectionsExportPost(body: ExportMonthOverviewFilter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Salary/corrections/export";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    monitoringGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult[]> {
        let _url = this.baseUrl + "/api/monitoring";

        return ApiService.sendRequest<SelfTestResult[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    monitoringJobByJobNameGet(params?:IJobParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/monitoring/job/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    selfTestJobsPost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/jobs";

        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }

    selfTestEmailqueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/emailqueue";

        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }

    monitoringJobsGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/jobs";

        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }

    selfTestDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/database";

        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }

    monitoringDatabaseGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/database";

        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }

    selfTestUpdateDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/update-database";

        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }

    serviceDownloadMessagesGet(params?:IDownloadMessagesParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-messages";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceMessagesDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/messages-dates";

        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceLogFilesGet(params?:ILogFilesParams, requestOptions?: IAjaxOptions): AxiosPromise<LogFileListItemModel[]> {
        let _url = this.baseUrl + "/api/Service/log-files";

        return ApiService.sendRequest<LogFileListItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceDownloadLogGet(params?:IDownloadLogParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-log";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceDownloadLogGzGet(params?:IDownloadLogGzParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-log-gz";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceLogFileDelete(params?:ILogFileParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/log-file";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceDownloadDeadlettersGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-deadletters";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/dates";

        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceMessageStatisticsGet(params?:IMessageStatisticsParams, requestOptions?: IAjaxOptions): AxiosPromise<MessageStatisticsModel[]> {
        let _url = this.baseUrl + "/api/Service/message-statistics";

        return ApiService.sendRequest<MessageStatisticsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceRestartSchedulerPost( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/restart-scheduler";

        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, null, requestOptions);
    }

    serviceInputQueueStatisticsGet( requestOptions?: IAjaxOptions): AxiosPromise<QueueStatisticsModel> {
        let _url = this.baseUrl + "/api/Service/input-queue-statistics";

        return ApiService.sendRequest<QueueStatisticsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceInputQueueDeadlettersPost( requestOptions?: IAjaxOptions): AxiosPromise<DeadletterInfoModel[]> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";

        return ApiService.sendRequest<DeadletterInfoModel[]>(AxiosMethod.POST, _url, null, requestOptions);
    }

    serviceInputQueueDeadlettersDelete(params?:IInputQueueDeadlettersParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceSapexportDownloadGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/sapexport/download";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }

    signalRUserGet( requestOptions?: IAjaxOptions): AxiosPromise<ConnectedClientModel[]> {
        let _url = this.baseUrl + "/api/SignalRUser";

        return ApiService.sendRequest<ConnectedClientModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

}

export interface IActivityDisplayNameResponse {
    map?: { [key: string]: string; };
}
export class ActivityDisplayNameResponse extends BaseApiModelClass< IActivityDisplayNameResponse > implements IActivityDisplayNameResponse {
    map?: { [key: string]: string; };
}

export interface IApiResult {
    content?: string;
}
export class ApiResult extends BaseApiModelClass< IApiResult > implements IApiResult {
    content?: string;
}

export interface IApiV1Job {
    id?: string;
    name: string;
    description?: string;
    jobType?: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus?: JobStatus;
    parameters: JobParameterDescriptionModel[];
    timestampDateTimeUtc?: Date;
    triggers: ApiV1JobTrigger[];
}
export class ApiV1Job extends BaseApiModelClass< IApiV1Job > implements IApiV1Job {
    id?: string;
    name: string;
    description?: string;
    jobType?: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus?: JobStatus;
    parameters: JobParameterDescriptionModel[];
    timestampDateTimeUtc?: Date;
    triggers: ApiV1JobTrigger[];
}

export interface IApiV1JobList {
    jobs?: ApiV1Job[];
    status?: SchedulerStatus;
    startupException?: string;
}
export class ApiV1JobList extends BaseApiModelClass< IApiV1JobList > implements IApiV1JobList {
    jobs?: ApiV1Job[];
    status?: SchedulerStatus;
    startupException?: string;
}

export interface IApiV1JobTrigger {
    executionId?: string;
    id: string;
    nextRunDateTime?: Date;
    lastRunDateTime?: Date;
    lastErrorMessage?: string;
    status?: JobStatus;
    isActive?: boolean;
    cronSchedule?: string;
    progressMessage?: string;
    scheduleUseZrhTimeZone?: boolean;
    scheduleMisfireLogic?: JobMisfireInstruction;
}
export class ApiV1JobTrigger extends BaseApiModelClass< IApiV1JobTrigger > implements IApiV1JobTrigger {
    executionId?: string;
    id: string;
    nextRunDateTime?: Date;
    lastRunDateTime?: Date;
    lastErrorMessage?: string;
    status?: JobStatus;
    isActive?: boolean;
    cronSchedule?: string;
    progressMessage?: string;
    scheduleUseZrhTimeZone?: boolean;
    scheduleMisfireLogic?: JobMisfireInstruction;
}

export enum CheckerTraineeFunction {
    None = "None",
    Ef = "Ef",
    ClEf = "ClEf",
    ScEf = "ScEf",
    Sf = "Sf",
    Lpl4 = "Lpl4",
    Lc = "Lc",
    Cl = "Cl",
    FLc = "FLc",
    Refam = "Refam",
    Lifus = "Lifus",
    CrpLc = "CrpLc",
    CompetencyCheck = "CompetencyCheck",
    Le = "Le",
    SafetyPilot = "SafetyPilot",
    EisCrew = "EisCrew",
    Rating = "Rating",
}

export interface ICheckerTraineeInfo {
    isChecker?: boolean;
    relatedPersonCode?: string;
    function?: CheckerTraineeFunction;
    functionName?: string;
    instructorQualification?: InstructorRequirements;
}
export class CheckerTraineeInfo extends BaseApiModelClass< ICheckerTraineeInfo > implements ICheckerTraineeInfo {
    isChecker?: boolean;
    relatedPersonCode?: string;
    function?: CheckerTraineeFunction;
    readonly functionName?: string;
    instructorQualification?: InstructorRequirements;
}

export enum ConfigType {
    Text = "Text",
    Boolean = "Boolean",
    Select = "Select",
}

export interface IConfigurationModel {
    key: string;
    group: string;
    value?: string;
    description?: string;
    type?: ConfigType;
    isSystem?: boolean;
    options?: string;
}
export class ConfigurationModel extends BaseApiModelClass< IConfigurationModel > implements IConfigurationModel {
    key: string;
    group: string;
    value?: string;
    description?: string;
    type?: ConfigType;
    isSystem?: boolean;
    options?: string;
}

export interface IConnectedClientModel {
    identity?: string;
    fullName?: string;
    count: number;
}
export class ConnectedClientModel extends BaseApiModelClass< IConnectedClientModel > implements IConnectedClientModel {
    identity?: string;
    fullName?: string;
    count: number;
}

export enum ContractType {
    None = "None",
    Fix = "Fix",
    Freelance = "Freelance",
    Fse = "Fse",
    Tzv = "Tzv",
}

export interface IDayCorrectionModel {
    amount?: number;
    comment?: string;
}
export class DayCorrectionModel extends BaseApiModelClass< IDayCorrectionModel > implements IDayCorrectionModel {
    amount?: number;
    comment?: string;
}

export interface IDeadletterInfoModel {
    id?: string;
    label?: MessageLabel;
    error?: string;
}
export class DeadletterInfoModel extends BaseApiModelClass< IDeadletterInfoModel > implements IDeadletterInfoModel {
    id?: string;
    label?: MessageLabel;
    error?: string;
}

export enum DirectionType {
    In = "In",
    Out = "Out",
    DeadletterToInbox = "DeadletterToInbox",
}

export enum DutyFlag {
    None = "None",
    NoBreak = "NoBreak",
    Pikett = "Pikett",
    FlightShiftedNextDay = "FlightShiftedNextDay",
    FlightShiftedPrevDay = "FlightShiftedPrevDay",
    IsLongHaulRelated = "IsLongHaulRelated",
    IntroFlight = "IntroFlight",
    ObserverFlight = "ObserverFlight",
}

export interface IDutyViewModel {
    personId?: string;
    date?: Date;
    activity?: string;
    posDestinationRcd?: string;
    posStartUtc?: Date;
    posEndUtc?: Date;
    flight?: string;
    remark?: string;
}
export class DutyViewModel extends BaseApiModelClass< IDutyViewModel > implements IDutyViewModel {
    personId?: string;
    date?: Date;
    activity?: string;
    posDestinationRcd?: string;
    posStartUtc?: Date;
    posEndUtc?: Date;
    flight?: string;
    remark?: string;
}

export interface IExportMonthOverviewFilter {
    periodId: number;
    personIds?: string[];
    asPdf?: boolean;
}
export class ExportMonthOverviewFilter extends BaseApiModelClass< IExportMonthOverviewFilter > implements IExportMonthOverviewFilter {
    periodId: number;
    personIds?: string[];
    asPdf?: boolean;
}

export interface IImportTypeModel {
    name: string;
    id: number;
}
export class ImportTypeModel extends BaseApiModelClass< IImportTypeModel > implements IImportTypeModel {
    name: string;
    id: number;
}

export enum InstructorRequirements {
    SFI = "SFI",
    TRIr = "TRIr",
    TRI = "TRI",
    SFE = "SFE",
    TRE = "TRE",
    TRE3y = "TRE3y",
    SeniorTre = "SeniorTre",
    TC = "TC",
    EBTI = "EBTI",
    TRIrLIFUS = "TRIrLIFUS",
    TRIrLT = "TRIrLT",
}

export interface IJobDetailsModel {
    name: string;
    isActive?: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}
export class JobDetailsModel extends BaseApiModelClass< IJobDetailsModel > implements IJobDetailsModel {
    name: string;
    isActive?: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}

export enum JobMisfireInstruction {
    Default = "Default",
    DoNothing = "DoNothing",
    FireAndProceed = "FireAndProceed",
    IgnoreMisfires = "IgnoreMisfires",
}

export interface IJobParameterDescriptionModel {
    name: string;
    value?: string;
    displayName?: string;
    type?: JobParameterType;
    isRequired?: boolean;
    enumValues: string[];
}
export class JobParameterDescriptionModel extends BaseApiModelClass< IJobParameterDescriptionModel > implements IJobParameterDescriptionModel {
    name: string;
    value?: string;
    displayName?: string;
    type?: JobParameterType;
    isRequired?: boolean;
    enumValues: string[];
}

export interface IJobParameterModel {
    name: string;
    value?: string;
}
export class JobParameterModel extends BaseApiModelClass< IJobParameterModel > implements IJobParameterModel {
    name: string;
    value?: string;
}

export enum JobParameterType {
    String = "String",
    Multiline = "Multiline",
    Integer = "Integer",
    Boolean = "Boolean",
    Enum = "Enum",
    Date = "Date",
    DateTime = "DateTime",
}

export interface IJobSaveParametersModel {
    jobName: string;
    triggerName: string;
    isActive?: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters?: JobParameterModel[];
    useZrhTimeZone?: boolean;
    misfireLogic?: JobMisfireInstruction;
}
export class JobSaveParametersModel extends BaseApiModelClass< IJobSaveParametersModel > implements IJobSaveParametersModel {
    jobName: string;
    triggerName: string;
    isActive?: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters?: JobParameterModel[];
    useZrhTimeZone?: boolean;
    misfireLogic?: JobMisfireInstruction;
}

export interface IJobSaveParametersResult {
    errors?: string[];
    hasErrors?: boolean;
}
export class JobSaveParametersResult extends BaseApiModelClass< IJobSaveParametersResult > implements IJobSaveParametersResult {
    errors?: string[];
    readonly hasErrors?: boolean;
}

export interface IJobStartModel {
    parameters?: JobParameterModel[];
}
export class JobStartModel extends BaseApiModelClass< IJobStartModel > implements IJobStartModel {
    parameters?: JobParameterModel[];
}

export enum JobStatus {
    Pending = "Pending",
    Success = "Success",
    Fail = "Fail",
}

export interface ILogFileListItemModel {
    name?: string;
    fileName?: string;
    extension?: string;
    size?: number;
    lastModified?: Date;
}
export class LogFileListItemModel extends BaseApiModelClass< ILogFileListItemModel > implements ILogFileListItemModel {
    name?: string;
    fileName?: string;
    extension?: string;
    size?: number;
    lastModified?: Date;
}

export enum MessageLabel {
    Error = "Error",
    AircraftMaintenance = "AircraftMaintenance",
    Aircraft = "Aircraft",
    AircraftType = "AircraftType",
    Airport = "Airport",
    Flight = "Flight",
    AcarsOooi = "AcarsOooi",
    AcarsM45 = "AcarsM45",
    Person = "Person",
    Rotation = "Rotation",
    PersonDay = "PersonDay",
    CrewNotification = "CrewNotification",
    CrewAssignment = "CrewAssignment",
    FlightMeal = "FlightMeal",
    JeppesenError = "JeppesenError",
    JeppesenFlight = "JeppesenFlight",
    JeppesenTrip = "JeppesenTrip",
    JeppesenDuty = "JeppesenDuty",
    JeppesenCheckerTrainee = "JeppesenCheckerTrainee",
    LegDetail = "LegDetail",
    AircraftsAssignment = "AircraftsAssignment",
    FlightMealService = "FlightMealService",
    SsimFlightAdded = "SsimFlightAdded",
    SsimFlightModified = "SsimFlightModified",
    SsimFlightDeleted = "SsimFlightDeleted",
    FlightPilotStatus = "FlightPilotStatus",
    FlightProtocol = "FlightProtocol",
    FlightWeight = "FlightWeight",
    AlteaDcsCatering = "AlteaDcsCatering",
    CateredMeals = "CateredMeals",
    KafkaReceived = "KafkaReceived",
    PersonAbsence = "PersonAbsence",
    IrregCase = "IrregCase",
    SabreCrewMessage = "SabreCrewMessage",
    Unknown = "Unknown",
}

export interface IMessageStatisticsItemModel {
    key: string;
    value: number;
}
export class MessageStatisticsItemModel extends BaseApiModelClass< IMessageStatisticsItemModel > implements IMessageStatisticsItemModel {
    key: string;
    value: number;
}

export interface IMessageStatisticsModel {
    messageType: string;
    statistics: MessageStatisticsItemModel[];
    directionType: DirectionType;
}
export class MessageStatisticsModel extends BaseApiModelClass< IMessageStatisticsModel > implements IMessageStatisticsModel {
    messageType: string;
    statistics: MessageStatisticsItemModel[];
    directionType: DirectionType;
}

export enum PermissionType {
    ViewRule = "ViewRule",
    EditRule = "EditRule",
    ViewSalary = "ViewSalary",
    SalaryManualCorrection = "SalaryManualCorrection",
    ProcessImportPeriod = "ProcessImportPeriod",
    ReleaseImportPeriod = "ReleaseImportPeriod",
    ViewServiceTools = "ViewServiceTools",
    EditServiceTools = "EditServiceTools",
    ViewTickets = "ViewTickets",
    EditTickets = "EditTickets",
    ViewTicketRefunds = "ViewTicketRefunds",
    EditTicketRefunds = "EditTicketRefunds",
    ViewDutyFree = "ViewDutyFree",
    EditDutyFree = "EditDutyFree",
    CanImpersonate = "CanImpersonate",
    CanImpersonateAsAdmin = "CanImpersonateAsAdmin",
    ViewShiftBonus = "ViewShiftBonus",
    EditShiftBonus = "EditShiftBonus",
    ReadyToReleasePeriod = "ReadyToReleasePeriod",
}

export interface IPermissionsResult {
    permissions: PermissionType[];
    originalPermissions?: PermissionType[];
}
export class PermissionsResult extends BaseApiModelClass< IPermissionsResult > implements IPermissionsResult {
    permissions: PermissionType[];
    originalPermissions?: PermissionType[];
}

export interface IPersonActivitiesInfo {
    id?: string;
    hasDuties?: boolean;
    activities?: string[];
}
export class PersonActivitiesInfo extends BaseApiModelClass< IPersonActivitiesInfo > implements IPersonActivitiesInfo {
    id?: string;
    hasDuties?: boolean;
    activities?: string[];
}

export interface IPersonCode {
    id?: string;
    code?: string;
}
export class PersonCode extends BaseApiModelClass< IPersonCode > implements IPersonCode {
    id?: string;
    code?: string;
}

export interface IPersonContractInfo {
    contractType?: ContractType;
    contractOfficePercentage?: number;
}
export class PersonContractInfo extends BaseApiModelClass< IPersonContractInfo > implements IPersonContractInfo {
    contractType?: ContractType;
    contractOfficePercentage?: number;
}

export interface IPersonDayComment {
    id?: number;
    comment?: string;
    modifiedAt?: Date;
    modifiedByDisplayName?: string;
    modifiedByEmail?: string;
}
export class PersonDayComment extends BaseApiModelClass< IPersonDayComment > implements IPersonDayComment {
    id?: number;
    comment?: string;
    modifiedAt?: Date;
    modifiedByDisplayName?: string;
    modifiedByEmail?: string;
}

export interface IPersonDayInfoResponse {
    personId: string;
    date: Date;
    dutyText: string;
}
export class PersonDayInfoResponse extends BaseApiModelClass< IPersonDayInfoResponse > implements IPersonDayInfoResponse {
    personId: string;
    date: Date;
    dutyText: string;
}

export interface IPersonDaySalary {
    personId: string;
    date: Date;
    moneyValue?: number;
    daysValue?: number;
    hoursValue?: number;
    comments?: PersonDayComment[];
    items?: PersonDaySalaryShortInfoItem[];
}
export class PersonDaySalary extends BaseApiModelClass< IPersonDaySalary > implements IPersonDaySalary {
    personId: string;
    date: Date;
    moneyValue?: number;
    daysValue?: number;
    hoursValue?: number;
    comments?: PersonDayComment[];
    items?: PersonDaySalaryShortInfoItem[];
}

export interface IPersonDaySalaryItem {
    ruleGroupId?: number;
    sapAccount: number;
    unit: SalaryItemUnit;
    type: SalaryItemType;
    comment?: string;
    amount?: number;
    modifiedDateTimeAt: Date;
    modifiedPrincipalDisplayName: string;
    modifiedPrincipalEmail: string;
}
export class PersonDaySalaryItem extends BaseApiModelClass< IPersonDaySalaryItem > implements IPersonDaySalaryItem {
    ruleGroupId?: number;
    sapAccount: number;
    unit: SalaryItemUnit;
    type: SalaryItemType;
    comment?: string;
    amount?: number;
    modifiedDateTimeAt: Date;
    modifiedPrincipalDisplayName: string;
    modifiedPrincipalEmail: string;
}

export interface IPersonDaySalaryShortInfoItem {
    commentId?: number;
    type?: SalaryItemType;
    unit?: SalaryItemUnit;
    amount?: number;
    specialRuleType?: SpecialRuleType;
    sapAccount?: number;
}
export class PersonDaySalaryShortInfoItem extends BaseApiModelClass< IPersonDaySalaryShortInfoItem > implements IPersonDaySalaryShortInfoItem {
    commentId?: number;
    type?: SalaryItemType;
    unit?: SalaryItemUnit;
    amount?: number;
    specialRuleType?: SpecialRuleType;
    sapAccount?: number;
}

export interface IPersonDutyItem {
    date: Date;
    activityCodeName: string;
    activityDisplayName?: string;
    isHistorized?: boolean;
    startUtc?: Date;
    endUtc?: Date;
    flightId?: string;
    originRcd?: string;
    destinationRcd?: string;
    locationFromRcd?: string;
    locationToRcd?: string;
    isLongHaul?: boolean;
    simulationType?: SimulationType;
    simulationMemberType?: SimulationMemberType;
    simulationInstructorRequirements?: InstructorRequirements;
    simulationLpl4TraineePersonName?: string;
    simulationLpl4TraineePersonId?: string;
    positioningDowngradeRefundType?: PositioningDowngradeRefundType;
    blockHours1DaySec?: number;
    checkerTraineeInfos?: CheckerTraineeInfo[];
    remarks?: string;
    isIntroduction?: boolean;
    flag?: DutyFlag;
}
export class PersonDutyItem extends BaseApiModelClass< IPersonDutyItem > implements IPersonDutyItem {
    date: Date;
    activityCodeName: string;
    activityDisplayName?: string;
    isHistorized?: boolean;
    startUtc?: Date;
    endUtc?: Date;
    flightId?: string;
    originRcd?: string;
    destinationRcd?: string;
    locationFromRcd?: string;
    locationToRcd?: string;
    isLongHaul?: boolean;
    simulationType?: SimulationType;
    simulationMemberType?: SimulationMemberType;
    simulationInstructorRequirements?: InstructorRequirements;
    simulationLpl4TraineePersonName?: string;
    simulationLpl4TraineePersonId?: string;
    positioningDowngradeRefundType?: PositioningDowngradeRefundType;
    blockHours1DaySec?: number;
    checkerTraineeInfos?: CheckerTraineeInfo[];
    remarks?: string;
    isIntroduction?: boolean;
    flag?: DutyFlag;
}

export interface IPersonInfo {
    id: string;
    code: string;
    fullName: string;
    functionNames?: string[];
    contracts?: PersonContractInfo[];
    status?: PersonSalaryPeriodStatus;
}
export class PersonInfo extends BaseApiModelClass< IPersonInfo > implements IPersonInfo {
    id: string;
    code: string;
    fullName: string;
    functionNames?: string[];
    contracts?: PersonContractInfo[];
    status?: PersonSalaryPeriodStatus;
}

export interface IPersonMonthItem {
    personId?: string;
    ruleGroupId?: number;
    sapAccount?: number;
    unit?: SalaryItemUnit;
    amount?: number;
    hasCorrections?: boolean;
}
export class PersonMonthItem extends BaseApiModelClass< IPersonMonthItem > implements IPersonMonthItem {
    personId?: string;
    ruleGroupId?: number;
    sapAccount?: number;
    unit?: SalaryItemUnit;
    amount?: number;
    hasCorrections?: boolean;
}

export enum PersonSalaryPeriodStatus {
    None = "None",
    Imported = "Imported",
    Failed = "Failed",
}

export interface IPersonSalaryResponse {
    items?: PersonDaySalary[];
    status?: SalaryPeriodStatus;
}
export class PersonSalaryResponse extends BaseApiModelClass< IPersonSalaryResponse > implements IPersonSalaryResponse {
    items?: PersonDaySalary[];
    status?: SalaryPeriodStatus;
}

export enum PositioningDowngradeRefundType {
    None = "None",
    PY = "PY",
    Y = "Y",
}

export interface IQueueStatisticsModel {
    queueName?: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn?: number;
    status?: SelfTestResultStatus;
}
export class QueueStatisticsModel extends BaseApiModelClass< IQueueStatisticsModel > implements IQueueStatisticsModel {
    queueName?: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn?: number;
    status?: SelfTestResultStatus;
}

export enum ResultStatus {
    Success = "Success",
    Fail = "Fail",
    NotRelevant = "NotRelevant",
}

export enum RuleActivityAdditionalType {
    SimulationMemberType = "SimulationMemberType",
    SimulationInstructorRequirements = "SimulationInstructorRequirements",
    SimulationLpl4 = "SimulationLpl4",
    Not = "Not",
    PositioningDowngradeRefundType = "PositioningDowngradeRefundType",
}

export interface IRuleCreateModel {
    periodDateFrom?: Date;
    periodDateTo?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    dutyComment?: string;
    flyingDutyPercentageFrom?: number;
    flyingDutyPercentageTo?: number;
    specialRuleType?: SpecialRuleType;
    specialRuleArguments?: string;
    contracts?: ContractType[];
    functions?: string[];
    licenses?: string[];
    duties?: RuleDutyModel[];
    successAction?: string;
    importType?: SalaryItemType;
    options?: RuleOptions[];
    lastUsedOn?: Date;
    nextRuleId?: number;
    previousRuleId?: number;
    previousRuleTillDate?: Date;
    ruleGroupId: number;
    originalRuleId?: number;
}
export class RuleCreateModel extends BaseApiModelClass< IRuleCreateModel > implements IRuleCreateModel {
    periodDateFrom?: Date;
    periodDateTo?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    dutyComment?: string;
    flyingDutyPercentageFrom?: number;
    flyingDutyPercentageTo?: number;
    specialRuleType?: SpecialRuleType;
    specialRuleArguments?: string;
    contracts?: ContractType[];
    functions?: string[];
    licenses?: string[];
    duties?: RuleDutyModel[];
    successAction?: string;
    importType?: SalaryItemType;
    options?: RuleOptions[];
    lastUsedOn?: Date;
    nextRuleId?: number;
    previousRuleId?: number;
    previousRuleTillDate?: Date;
    ruleGroupId: number;
    originalRuleId?: number;
}

export interface IRuleDutyModel {
    id?: string;
    code?: string;
    displayName?: string;
    additionalType?: RuleActivityAdditionalType;
    additionalValue?: string;
}
export class RuleDutyModel extends BaseApiModelClass< IRuleDutyModel > implements IRuleDutyModel {
    id?: string;
    code?: string;
    displayName?: string;
    additionalType?: RuleActivityAdditionalType;
    additionalValue?: string;
}

export interface IRuleDutyOption {
    code?: string;
    displayName?: string;
}
export class RuleDutyOption extends BaseApiModelClass< IRuleDutyOption > implements IRuleDutyOption {
    code?: string;
    displayName?: string;
}

export interface IRuleDutyResponse {
    duties?: RuleDutyOption[];
}
export class RuleDutyResponse extends BaseApiModelClass< IRuleDutyResponse > implements IRuleDutyResponse {
    duties?: RuleDutyOption[];
}

export interface IRuleEditModel {
    periodDateFrom?: Date;
    periodDateTo?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    dutyComment?: string;
    flyingDutyPercentageFrom?: number;
    flyingDutyPercentageTo?: number;
    specialRuleType?: SpecialRuleType;
    specialRuleArguments?: string;
    contracts?: ContractType[];
    functions?: string[];
    licenses?: string[];
    duties?: RuleDutyModel[];
    successAction?: string;
    importType?: SalaryItemType;
    options?: RuleOptions[];
    lastUsedOn?: Date;
    nextRuleId?: number;
    previousRuleId?: number;
    previousRuleTillDate?: Date;
}
export class RuleEditModel extends BaseApiModelClass< IRuleEditModel > implements IRuleEditModel {
    periodDateFrom?: Date;
    periodDateTo?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    dutyComment?: string;
    flyingDutyPercentageFrom?: number;
    flyingDutyPercentageTo?: number;
    specialRuleType?: SpecialRuleType;
    specialRuleArguments?: string;
    contracts?: ContractType[];
    functions?: string[];
    licenses?: string[];
    duties?: RuleDutyModel[];
    successAction?: string;
    importType?: SalaryItemType;
    options?: RuleOptions[];
    lastUsedOn?: Date;
    nextRuleId?: number;
    previousRuleId?: number;
    previousRuleTillDate?: Date;
}

export interface IRuleGroupItem {
    id: number;
    name?: string;
    bandName?: string;
    sortOrder: number;
    unit: SalaryItemUnit;
    importType?: string;
    sapAccount: number;
    importTypeId?: SalaryItemType;
    displayText?: string;
}
export class RuleGroupItem extends BaseApiModelClass< IRuleGroupItem > implements IRuleGroupItem {
    id: number;
    name?: string;
    bandName?: string;
    sortOrder: number;
    unit: SalaryItemUnit;
    importType?: string;
    sapAccount: number;
    importTypeId?: SalaryItemType;
    readonly displayText?: string;
}

export interface IRuleGroupModel {
    id: number;
    name: string;
    bandName?: string;
    sortOrder: number;
    unit: SalaryItemUnit;
    sapAccount: number;
}
export class RuleGroupModel extends BaseApiModelClass< IRuleGroupModel > implements IRuleGroupModel {
    id: number;
    name: string;
    bandName?: string;
    sortOrder: number;
    unit: SalaryItemUnit;
    sapAccount: number;
}

export interface IRuleGroupResponse {
    groups?: RuleGroupItem[];
}
export class RuleGroupResponse extends BaseApiModelClass< IRuleGroupResponse > implements IRuleGroupResponse {
    groups?: RuleGroupItem[];
}

export interface IRuleGroupUpdateModel {
    id: number;
    name: string;
    sapAccount: number;
}
export class RuleGroupUpdateModel extends BaseApiModelClass< IRuleGroupUpdateModel > implements IRuleGroupUpdateModel {
    id: number;
    name: string;
    sapAccount: number;
}

export interface IRuleHistoryResponse {
    originalRuleId?: number;
    items?: RuleHistoryResponseItem[];
}
export class RuleHistoryResponse extends BaseApiModelClass< IRuleHistoryResponse > implements IRuleHistoryResponse {
    originalRuleId?: number;
    items?: RuleHistoryResponseItem[];
}

export interface IRuleHistoryResponseItem {
    ruleId?: number;
    createdAtUtc?: Date;
    createdBy?: string;
    modifiedAtUtc?: Date;
    modifiedBy?: string;
    changes?: string;
}
export class RuleHistoryResponseItem extends BaseApiModelClass< IRuleHistoryResponseItem > implements IRuleHistoryResponseItem {
    ruleId?: number;
    createdAtUtc?: Date;
    createdBy?: string;
    modifiedAtUtc?: Date;
    modifiedBy?: string;
    changes?: string;
}

export interface IRuleListResponse {
    rules?: RuleModel[];
}
export class RuleListResponse extends BaseApiModelClass< IRuleListResponse > implements IRuleListResponse {
    rules?: RuleModel[];
}

export interface IRuleModel {
    periodDateFrom?: Date;
    periodDateTo?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    dutyComment?: string;
    flyingDutyPercentageFrom?: number;
    flyingDutyPercentageTo?: number;
    specialRuleType?: SpecialRuleType;
    specialRuleArguments?: string;
    contracts?: ContractType[];
    functions?: string[];
    licenses?: string[];
    duties?: RuleDutyModel[];
    successAction?: string;
    importType?: SalaryItemType;
    options?: RuleOptions[];
    lastUsedOn?: Date;
    nextRuleId?: number;
    previousRuleId?: number;
    previousRuleTillDate?: Date;
    id: number;
    originalRuleId?: number;
    ruleGroupId?: number;
    sapAccount?: number;
    groupName?: string;
    bandName?: string;
}
export class RuleModel extends BaseApiModelClass< IRuleModel > implements IRuleModel {
    periodDateFrom?: Date;
    periodDateTo?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    dutyComment?: string;
    flyingDutyPercentageFrom?: number;
    flyingDutyPercentageTo?: number;
    specialRuleType?: SpecialRuleType;
    specialRuleArguments?: string;
    contracts?: ContractType[];
    functions?: string[];
    licenses?: string[];
    duties?: RuleDutyModel[];
    successAction?: string;
    importType?: SalaryItemType;
    options?: RuleOptions[];
    lastUsedOn?: Date;
    nextRuleId?: number;
    previousRuleId?: number;
    previousRuleTillDate?: Date;
    id: number;
    originalRuleId?: number;
    ruleGroupId?: number;
    sapAccount?: number;
    groupName?: string;
    bandName?: string;
}

export enum RuleOptions {
    None = "None",
    NotForIntroduction = "NotForIntroduction",
    NotForCompensated = "NotForCompensated",
    FTzvExtraPay = "FTzvExtraPay",
}

export interface IRuleUsageModel {
    id: number;
    isUsed: boolean;
    description?: string;
}
export class RuleUsageModel extends BaseApiModelClass< IRuleUsageModel > implements IRuleUsageModel {
    id: number;
    isUsed: boolean;
    description?: string;
}

export interface ISalaryDailyViewModelResponse {
    groups: RuleGroupItem[];
    days: SalaryDailyViewModelResponseItem[];
}
export class SalaryDailyViewModelResponse extends BaseApiModelClass< ISalaryDailyViewModelResponse > implements ISalaryDailyViewModelResponse {
    groups: RuleGroupItem[];
    days: SalaryDailyViewModelResponseItem[];
}

export interface ISalaryDailyViewModelResponseItem {
    date: Date;
    duty: string;
    releasedDuty: string;
    routing?: string;
    duties: PersonDutyItem[];
    items: PersonDaySalaryItem[];
    blockHours1DaySec?: number;
    actualBlockHours1DaySec?: number;
    remarks?: string;
    dutyHours1DaySec?: number;
}
export class SalaryDailyViewModelResponseItem extends BaseApiModelClass< ISalaryDailyViewModelResponseItem > implements ISalaryDailyViewModelResponseItem {
    date: Date;
    duty: string;
    releasedDuty: string;
    routing?: string;
    duties: PersonDutyItem[];
    items: PersonDaySalaryItem[];
    blockHours1DaySec?: number;
    actualBlockHours1DaySec?: number;
    remarks?: string;
    dutyHours1DaySec?: number;
}

export interface ISalaryItemCreateModel {
    personId?: string;
    periodId?: number;
    importTypeId?: number;
    date?: Date;
    amount?: number;
    comments?: string;
}
export class SalaryItemCreateModel extends BaseApiModelClass< ISalaryItemCreateModel > implements ISalaryItemCreateModel {
    personId?: string;
    periodId?: number;
    importTypeId?: number;
    date?: Date;
    amount?: number;
    comments?: string;
}

export enum SalaryItemType {
    Rule = "Rule",
    ManualCorrection = "ManualCorrection",
    ImportTickets = "ImportTickets",
    ImportTicketRefunds = "ImportTicketRefunds",
    ImportDutyFree = "ImportDutyFree",
    ImportShiftBonus = "ImportShiftBonus",
}

export enum SalaryItemUnit {
    Money = "Money",
    Days = "Days",
    Hours = "Hours",
    MoneyPerHour = "MoneyPerHour",
    MoneyFactor = "MoneyFactor",
}

export interface ISalaryItemViewModel {
    id: number;
    personId?: string;
    date?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    comments?: string;
}
export class SalaryItemViewModel extends BaseApiModelClass< ISalaryItemViewModel > implements ISalaryItemViewModel {
    id: number;
    personId?: string;
    date?: Date;
    amount?: number;
    unit?: SalaryItemUnit;
    comments?: string;
}

export interface ISalaryMonthViewModelResponse {
    personId: string;
    personCode: string;
    personFullName: string;
    groups?: PersonMonthItem[];
    personFunctions: string[];
    personContracts: PersonContractInfo[];
    status?: PersonSalaryPeriodStatus;
}
export class SalaryMonthViewModelResponse extends BaseApiModelClass< ISalaryMonthViewModelResponse > implements ISalaryMonthViewModelResponse {
    personId: string;
    personCode: string;
    personFullName: string;
    groups?: PersonMonthItem[];
    personFunctions: string[];
    personContracts: PersonContractInfo[];
    status?: PersonSalaryPeriodStatus;
}

export interface ISalaryPeriodHistoryResponseModel {
    periodId?: number;
    items?: SalaryPeriodHistoryResponseModelItem[];
}
export class SalaryPeriodHistoryResponseModel extends BaseApiModelClass< ISalaryPeriodHistoryResponseModel > implements ISalaryPeriodHistoryResponseModel {
    periodId?: number;
    items?: SalaryPeriodHistoryResponseModelItem[];
}

export interface ISalaryPeriodHistoryResponseModelItem {
    changedAtUtc?: Date;
    changedBy?: string;
    oldStatus?: string;
    newStatus?: string;
}
export class SalaryPeriodHistoryResponseModelItem extends BaseApiModelClass< ISalaryPeriodHistoryResponseModelItem > implements ISalaryPeriodHistoryResponseModelItem {
    changedAtUtc?: Date;
    changedBy?: string;
    oldStatus?: string;
    newStatus?: string;
}

export interface ISalaryPeriodResponseItem {
    id: number;
    codeName?: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    status: SalaryPeriodStatus;
    errorMessage?: string;
}
export class SalaryPeriodResponseItem extends BaseApiModelClass< ISalaryPeriodResponseItem > implements ISalaryPeriodResponseItem {
    id: number;
    codeName?: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    status: SalaryPeriodStatus;
    errorMessage?: string;
}

export enum SalaryPeriodStatus {
    Pending = "Pending",
    Imported = "Imported",
    Failed = "Failed",
    ReadyToRelease = "ReadyToRelease",
    Released = "Released",
}

export enum SchedulerStatus {
    ServiceNotStarted = "ServiceNotStarted",
    WaitingForDatabase = "WaitingForDatabase",
    SchedulingJobs = "SchedulingJobs",
    FailedToStart = "FailedToStart",
    SchedulingPostponedJobs = "SchedulingPostponedJobs",
    Starting = "Starting",
    Started = "Started",
    ShuttingDown = "ShuttingDown",
    StutDown = "StutDown",
}

export interface ISelfTestResult {
    name?: string;
    status?: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}
export class SelfTestResult extends BaseApiModelClass< ISelfTestResult > implements ISelfTestResult {
    name?: string;
    status?: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}

export enum SelfTestResultStatus {
    Success = "Success",
    Warning = "Warning",
    Fail = "Fail",
}

export enum SimulationMemberType {
    Crew = "Crew",
    Instructor = "Instructor",
    Assist = "Assist",
    Observer = "Observer",
}

export enum SimulationType {
    None = "None",
    LdgRecency = "LdgRecency",
    AirportRecency = "AirportRecency",
    Skilltest = "Skilltest",
    Check = "Check",
    EbtDay1 = "EbtDay1",
    EbtDay2 = "EbtDay2",
    Refresher = "Refresher",
    Training = "Training",
}

export enum SpecialRuleType {
    None = "None",
    OverNightHotel = "OverNightHotel",
    MinZrhTime = "MinZrhTime",
    BlockHours = "BlockHours",
    HasFlightOrPos = "HasFlightOrPos",
    ConsecutiveLays = "ConsecutiveLays",
    BackPositioning = "BackPositioning",
    Weekend = "Weekend",
    HourlyShift = "HourlyShift",
    TrainingChecker = "TrainingChecker",
    Location = "Location",
    NonFlightRotation = "NonFlightRotation",
    WeekendHoliday = "WeekendHoliday",
    AgeAddition = "AgeAddition",
    FreelancerRotationDays = "FreelancerRotationDays",
    LocationChange = "LocationChange",
    FlightNumber = "FlightNumber",
    SimType = "SimType",
    RotationType = "RotationType",
    AnnualSalaryPercent = "AnnualSalaryPercent",
    BackPositioning20DH = "BackPositioning20DH",
    CounterBased = "CounterBased",
}

export interface IValidatePeriodResultResponse {
    personId: string;
    hasNoDuties?: boolean;
    ruleResults: ValidatePeriodRuleResultModel[];
}
export class ValidatePeriodResultResponse extends BaseApiModelClass< IValidatePeriodResultResponse > implements IValidatePeriodResultResponse {
    personId: string;
    hasNoDuties?: boolean;
    ruleResults: ValidatePeriodRuleResultModel[];
}

export interface IValidatePeriodRuleResultModel {
    ruleId: number;
    date: Date;
    isSuccess: boolean;
    conditionResults?: ValidateRuleConditionResultModel[];
}
export class ValidatePeriodRuleResultModel extends BaseApiModelClass< IValidatePeriodRuleResultModel > implements IValidatePeriodRuleResultModel {
    ruleId: number;
    date: Date;
    isSuccess: boolean;
    conditionResults?: ValidateRuleConditionResultModel[];
}

export interface IValidateRuleConditionResultModel {
    status: ResultStatus;
    conditionName: string;
    details?: string;
}
export class ValidateRuleConditionResultModel extends BaseApiModelClass< IValidateRuleConditionResultModel > implements IValidateRuleConditionResultModel {
    status: ResultStatus;
    conditionName: string;
    details?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}